$(document).ready(function () {
    $('.nav-tabs [data-toggle="tab"]').on('show.bs.tab', function ($ev) {
        $('[data-tab-content="' + $($ev.target).attr('aria-controls') + '"]')
            .removeClass('d-none')
            .addClass('d-flex');
        $('[data-tab-content="' + $($ev.relatedTarget).attr('aria-controls') + '"]')
            .addClass('d-none')
            .removeClass('d-flex');
    });

    // tab hash state
    if (window.location.hash) {
        var tabLink = $('[role="tablist"] [data-toggle][href="' + window.location.hash + '"]');
        if (tabLink.length === 1) {
            tabLink.trigger('click');
        }
    }
    $('[role="tablist"] a[data-toggle]').on('shown.bs.tab', function (event) {
        if (window.location.hash !== $(event.target).attr('href')) {
            history.pushState(null, null, $(event.target).attr('href'));
        }
    });

    function locationHashChanged(e) {
        console.log(location.hash);
        console.log(e.oldURL, e.newURL);
        var tabLink = $('[role="tablist"] [data-toggle][href="' + window.location.hash + '"]');
        if (tabLink.length === 1) {
            tabLink.trigger('click');
        } else {
            $($('[role="tablist"] [data-toggle]')[0]).trigger('click');
        }
    }

    window.onhashchange = locationHashChanged;
    // end: tab hash state

    $('[role="tablist"] a[data-toggle]').on('shown.bs.tab', function (event) {
        var targetTab = $('[data-tab-content="' + $(event.target).attr('aria-controls') + '"]');
        $.each(targetTab.find('[data-tab-load]'), function () {
            connection.loadPart($(this));
        });
    });
});
